import { Course } from 'src/store/models/timetable/index.js'
import Timetable from 'src/api/timetable.js'
import GlobalPrototypes from 'src/config/services/globalPrototypes.ts'

const defaultState = () => ({
  available_courses: [],
  userEvent: {},
  entityLessons: {
    users: {},
    grades: {},
    teachers: {},
    bookables: {}
  },
  substitutionChangeTime: null,
  etag: null,
  uploadProgress: {},
  noticeCreation: {}
})

export const state = defaultState()

export const getters = {
  NOTICE_CREATION (state) {
    return state.noticeCreation
  }
}

export const mutations = {
  RESET_STATE (state) {
    Object.assign(state, defaultState())
  },
  SET_AVAILABLE_COURSES (state, courses) {
    state.available_courses = courses
  },
  SET_ENTITY_LESSONS (state, { entityType, entityId, lessonIds }) {
    console.log('setting entity lessons - entityType, entityId', !entityType || !entityId)
    if (!entityType || !entityId) return false
    state.entityLessons[entityType][entityId] = lessonIds
  },
  SET_SUBSTITUTION_TIME (state, time) {
    state.substitutionChangeTime = time ? GlobalPrototypes.moment(time) : null
  },
  SET_ETAG (state, etag) {
    state.etag = etag
  },
  SET_FILE_UPLOAD_PROGRESS (state, { progress, id }) {
    state.uploadProgress = { ...state.uploadProgress, [id]: { progress, id } }
  },
  SET_PENDING_FILE_UPLOAD (state, { id }) {
    if (!state.uploadProgress) state.uploadProgress = {}
    const filter = Object.entries(state.uploadProgress)
      .filter(([_, value]) => value.id !== id)
    state.uploadProgress = Object.fromEntries(filter)
  },
  SET_NOTICE_CREATION (state, notice) {
    if (!notice) return
    state.noticeCreation = GlobalPrototypes.clone(notice)
  },
  SET_NOTICE_CREATION_USERS (state, users) {
    if (!users?.length) return
    state.noticeCreation = { ...state.noticeCreation, localUsers: users }
  }
}

export const actions = {
  shouldCourseSelection ({ dispatch }, userId) {
    return dispatch('getTimetableChange', { userId })
  },

  async getTimetableChange ({ commit }, { userId, overwrite }) {
    const response = await GlobalPrototypes.axios({ method: 'options', url: Timetable.timetableAvailableUrl(userId), showMessages: false })

    // commit('SET_SUBSTITUTION_TIME', response.headers['last-uploaded'])

    if (!overwrite && !Number(response.headers['need-change'])) { return false }

    const responseCourses = await Timetable.getTimetableAvailable(userId)

    const { courses } = responseCourses.data

    Course.insertOrUpdate({ data: Object.values(courses) })

    // commit('SET_USER_LESSONS', {
    //   userId: userId,
    //   lessonIds: Object.keys(lessons).map(id => Number(id))
    // })

    commit('SET_AVAILABLE_COURSES', Object.keys(courses).map(id => Number(id)))
    return true
  }
}
